import { render, staticRenderFns } from "./ArgesGaleriasAlta.vue?vue&type=template&id=3b07a9b4&scoped=true&"
import script from "./ArgesGaleriasAlta.vue?vue&type=script&lang=ts&"
export * from "./ArgesGaleriasAlta.vue?vue&type=script&lang=ts&"
import style0 from "./ArgesGaleriasAlta.vue?vue&type=style&index=0&id=3b07a9b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07a9b4",
  null
  
)

export default component.exports